const postLiveAccountPayload = (formField) => {
  const payload = {
    brandId: [formField?.brand?.id],
    name: formField?.accountId,
    accountLivestreamId: formField?.parentAccount?.id,
    storeName: formField?.storeName,
  };

  if (formField?.platform) payload.ecommerceId = `${formField?.platform?.id}`;
  if (formField?.accountType) payload.accountTypeId = `${formField?.accountType?.id}`;

  return payload;
};

export default postLiveAccountPayload;
